/* eslint-disable no-unused-vars */
import { memo, useMemo } from 'react';
import styled, { css } from 'styled-components';
import { ParagraphWithTooltip } from 'components';
import { Palette } from 'config';

const statuses = {
  0: 'Active',
  1: 'Disabled',
};

export const DropDownItem = memo(
  ({ name, bn_bannerid, status, searchValue$, handleCreativeChange, dropDownIsOpen$ }) => {
    const isBannerId = useMemo(() => {
      if (typeof bn_bannerid === 'number') return true;
      return false;
    }, [bn_bannerid]);

    return (
      <Container
        onClick={() => {
          handleCreativeChange(bn_bannerid);
          dropDownIsOpen$.value = false;
        }}
      >
        <Box>
          <ParagraphWithTooltip
            text={name || 'New creative'}
            style={{ fontSize: '20px', fontWeight: '500' }}
            search={searchValue$.value}
            isHighlight
            highlightStyle={{ color: `${Palette.Primary._500}`, fontWeight: '500' }}
          />
          <ParagraphWithTooltip
            search={searchValue$.value}
            isHighlight
            highlightStyle={{ color: `${Palette.Primary._500}`, fontWeight: '500' }}
            text={`ID: ${bn_bannerid}`}
            style={{
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: '400',
              lineHeight: '16px',
              visibility: `${!isBannerId && 'hidden'}`,
            }}
          />
        </Box>
        <StatusBox status={status}>{statuses[status]}</StatusBox>
      </Container>
    );
  },
);

DropDownItem.displayName = 'DropDownItem';

const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  border: 1px solid white;
  padding: 8px 16px;
  cursor: pointer;
  :hover {
    border-radius: 4px;
    background: ${Palette.PrimaryGray._100};
  }
  :active {
    border-radius: 4px;
    border: 1px solid ${Palette.Primary._300};
    background: ${Palette.Primary._000};
  }
`;
const Box = styled.div`
  width: 70%;
`;

const StatusBox = styled.p`
  ${({ status }) => {
    switch (status) {
      case 0:
        return css`
          color: ${Palette.Primary._500};
          border: 1px solid ${Palette.Primary._300};
          background: ${Palette.Primary._000};
        `;
      case 1:
        return css`
          color: ${Palette.PrimaryGray._500};
          border: 1px solid ${Palette.PrimaryGray._300};
          background: ${Palette.PrimaryGray._000};
        `;

      default:
        return '';
    }
  }}
  align-self: start;
  padding: 0 4px;
  border-radius: 2px;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  height: 16px;
`;
